import axios from "axios";

export const getAllVendors = async (tenantId, companyId, branchId) => {
  const res = await axios.get(
    `${process.env.REACT_APP_VENDORS_API_SERVER_BASE_URL}/${tenantId}/${companyId}/${branchId}`
  );
  return res?.data?.data;
};

export const getVendor = async (tenantId, companyId, branchId, id) => {
  const res = await axios.get(
    `${process.env.REACT_APP_VENDORS_API_SERVER_BASE_URL}/show/${tenantId}/${companyId}/${branchId}/${id}`
  );
  return res?.data?.data;
};

